import { render, staticRenderFns } from "./studentTesthistory.vue?vue&type=template&id=aed96450&scoped=true&"
import script from "./studentTesthistory.vue?vue&type=script&lang=js&"
export * from "./studentTesthistory.vue?vue&type=script&lang=js&"
import style0 from "./studentTesthistory.vue?vue&type=style&index=0&id=aed96450&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed96450",
  null
  
)

export default component.exports